import { styled } from '@mui/system';

export const Wrapper = styled('div')``;

export const Form = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
export const Actions = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;

  > div {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;

export const h6 = styled('h6')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
  vertical-align: center;
  color: ${({ theme }) => theme.palette.text.main};
`;
